import { getConditionalObject } from 'utils/data';

// Prism draws the field frame and lets the host recolour it, toolbar included. A host that
// frames the field itself hides Prism's frame unless the field is invalid.
const getFieldBorderColor = ({ palette }, { error, hasFrame }) => {
  if (error) {
    return palette.error.main;
  }

  return hasFrame ? null : 'transparent';
};

export const getRootSx = (theme, { error, hasFrame, fillHeight }) => {
  const borderColor = getFieldBorderColor(theme, { error, hasFrame });

  return {
    width: '100%',
    ...getConditionalObject(fillHeight, { height: '100%' }),
    ...getConditionalObject(!!borderColor, () => ({ '--prism-field-border': borderColor })),
  };
};

// A toolbar portalled into a host row takes the rest of the row, so it measures the room it has.
export const portalledToolbarStyles = { flexGrow: 1, minWidth: 0 };
